"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHeading_1 = __importDefault(require("components/common/table/TableHeading"));
var ClientsTableRow_1 = __importDefault(require("./ClientsTableRow"));
var ClientsTable = function (_a) {
    var sort = _a.sort, data = _a.data, onChangeSort = _a.onChangeSort, onDelete = _a.onDelete;
    return (react_1.default.createElement("div", { className: 'table' },
        react_1.default.createElement("div", { className: 'table__head flex flex-row' },
            react_1.default.createElement(TableHeading_1.default, { name: 'Image', sortable: false }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Name', sortable: true, active: sort.name === 'Name', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Website URL', sortable: true, active: sort.name === 'Website URL', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Action', sortable: false })),
        react_1.default.createElement("div", { className: 'table__body' },
            data.length > 0 &&
                data.map(function (product) { return (react_1.default.createElement(ClientsTableRow_1.default, { onDelete: onDelete, key: product.id, data: product })); }),
            data.length <= 0 &&
                react_1.default.createElement("p", { className: 'table__empty' }, "There are no clients to show"))));
};
exports.default = ClientsTable;
